export const CREATE = "CREATE_STATIC_CONTENT";

export const READ = "FETCH_STATIC_CONTENT";

export const READ_ALL = "FETCH_ALL_STATIC_CONTENT";

export const UPDATE = "UPDATE_STATIC_CONTENT";

export const DELETE = "DELETE_STATIC_CONTENT";